import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from './PublicLayout';
import TermsConditions from '../Components/TermsConditions';

const TermsAndConditions = () => (
  <PublicLayout>
      <Box p={4}>
<TermsConditions />
      </Box>
  </PublicLayout>
);

export default TermsAndConditions;